import React from "react"
import MaintainImage from "@/public/img/store/maintain.png"
import Image from "next/image"

export const MaintainScreen = () => {
  return (
    <div className="max-w-[1280px] mx-auto min-h-[90dvh] md:min-h-0 flex flex-col mt-[40px] mx-auto">
      <Image
        src={MaintainImage}
        alt="maintain"
        width={265}
        height={265}
        className="mx-auto"
      />
      <h1 className="text-[96px] text-center Nunito-700 text-[#3263E4] xs:text-[40px]">
        Opps !
      </h1>
      <p className="text-center text-[#28253E] Nunito-500 text-[30px] xs:text-[24px]">
        Cổng thanh toán cho game hiện đang bảo trì. <br />
        Vui lòng quay lại sau.
      </p>
    </div>
  )
}
